module.exports = __webpack_public_path__ + "img/iriomote_11.c6236647.jpg";